import {GET_AdmiDetails} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminData: null,
    //Message:''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_AdmiDetails:
            return {
                AdminData: action.body,
                //Message:action.msg
              
            }
           

        default:
            return state;
    }
}